import { useAuthStore } from '@/core/store/auth'

export const CONTENT_TYPE = {
  WORD: 'WORD',
  IMAGE: 'IMAGE'
}

export const LOCK_TTL_MS = 30 * 60 * 1000

export const MOCK_USERS = {
  1: { id: 1, displayName: '杨旭鸣' }
}

/** API 拉取 bundle 或登录后写入，用于显示创建者昵称 */
const userDisplayNameRegistry = {}

export function registerUserDisplayName(userId, displayName) {
  if (userId != null && displayName) {
    userDisplayNameRegistry[userId] = displayName
  }
}

export function getUserDisplayName(userId) {
  if (userId == null) return '—'
  const auth = useAuthStore()
  if (auth.user?.id === userId && auth.user?.displayName) {
    return auth.user.displayName
  }
  if (userDisplayNameRegistry[userId]) {
    return userDisplayNameRegistry[userId]
  }
  return MOCK_USERS[userId]?.displayName || `用户${userId}`
}
